export class ProductOption {
  productOptionId;
  productOptionName;
  productOptionOverlay;
  productOptionPreview;

  constructor(jsonData) {
    Object.assign(this, jsonData);
  }
}
